module.exports = __webpack_public_path__ + "static/happiness-ee7b6509ceb6220bd92ef3cbae004712.png";